<template>
  <edit-field ref="EDIT_INFO"
              :bold="bold"
              :contextId=contextId
              :dataTable="dataTable"
              :disabled=readOnly
              :editFieldInfo=editFieldInfo
              :hideLabel="hideLabel"
              :max=max
              :min=min
              :required=required
              :singleLine=true
              :value="value == '0' ? '' : value"
              @context=setInitValue
              @error=setError
              @updated=setUpdated>
  </edit-field>
</template>

<script lang="ts">
import EditBase from '@/framework/base/components/EditBase';
import EditField from '@/framework/base/components/EditField.vue';
import { EditFieldType, FieldInfo } from '@/framework/base/components/FieldInfo';
import { MapRessource } from '@/framework/base/helpers/Ressources';
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    EditField
  },
  extends: EditBase,
  computed: {
    editFieldInfo(): FieldInfo {
      const type = EditFieldType.STRING;
      const precision = 0;
      const format = null;
      const mask = null;
      const focus = null;
      const live = null;
      return new FieldInfo(this.ressource, type, precision, mask, format, focus, live);
    },
    ressource() {
      const customRessource = new MapRessource();
      customRessource.label = this.libelle;
      return customRessource
    }
  },
  methods: {
    missing(): boolean {
      // @ts-expect-error : generated method
      return this.$refs.EDIT_CURRENCY.missing();
    },
    touch(): boolean {
      // @ts-expect-error : generated method
      return this.$refs.EDIT_INFO.touch();
    },
    setFocus(): void {
      // @ts-expect-error : generated method
      this.$refs.EDIT_INFO.setFocus();
    }
  }
})

</script>
